import axios from 'axios';
import { DEV_BASE_URL } from "../constants";

const api = axios.create({
  baseURL: DEV_BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
